import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthRoutes, RouteParamsTypes, Modules, NonAuthRoutes } from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import InternalUsersList from '../modules/iam/internal-users/list';
import InternalUserForm from '../modules/iam/internal-users/form';
import AccessReviewList from '../modules/iam/access-reviews';
import AccessReviewDetail from '../modules/iam/access-reviews/detail';
import TenantUsersList from '../modules/tenant-users/list';
import TenantUserForm from '../modules/tenant-users/form';

const Iam: React.FC = () => {
  return (
    <Routes>
      <Route path={AuthRoutes.internalUsers}>
        <Route
          path={AuthRoutes.internalUsers + RouteParamsTypes.blank}
          element={<ProtectedRoute component={InternalUsersList} />}
        />
        <Route
          path={AuthRoutes.internalUsers + RouteParamsTypes.add}
          element={<ProtectedRoute component={InternalUserForm} />}
        />
        <Route
          path={AuthRoutes.internalUsers + RouteParamsTypes.edit + RouteParamsTypes.id}
          element={<ProtectedRoute component={InternalUserForm} />}
        />
      </Route>

      <Route path={AuthRoutes.tenantUsers}>
        <Route
          path={AuthRoutes.tenantUsers + RouteParamsTypes.blank}
          element={<ProtectedRoute component={TenantUsersList} />}
        />
        <Route
          path={AuthRoutes.tenantUsers + RouteParamsTypes.add}
          element={<ProtectedRoute component={TenantUserForm} />}
        />
        <Route
          path={AuthRoutes.tenantUsers + RouteParamsTypes.edit + RouteParamsTypes.id}
          element={<ProtectedRoute component={TenantUserForm} />}
        />
      </Route>

      <Route path={AuthRoutes.accessReviews}>
        <Route
          path={AuthRoutes.accessReviews + RouteParamsTypes.blank}
          element={<ProtectedRoute component={AccessReviewList} />}
        />
        <Route
          path={AuthRoutes.accessReviews + RouteParamsTypes.id}
          element={<ProtectedRoute component={AccessReviewDetail} />}
        />
      </Route>

      <Route
        path={RouteParamsTypes.blank}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default Iam;
